import { render, staticRenderFns } from "./MultiLabelDropDown.vue?vue&type=template&id=0ff551f0&scoped=true&"
import script from "./MultiLabelDropDown.vue?vue&type=script&lang=js&"
export * from "./MultiLabelDropDown.vue?vue&type=script&lang=js&"
import style0 from "./MultiLabelDropDown.vue?vue&type=style&index=0&id=0ff551f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff551f0",
  null
  
)

export default component.exports